module.exports = __webpack_public_path__ + "img/sport-99-@3x.5a4370f4.png";